import Vue from 'vue'
import * as Cookies from 'tiny-cookie'

const cookies = {
  install () {
    Vue.prototype.$cookies = Cookies
  }
}

Vue.use(cookies)